import { FC } from "react";

export interface DefaultCTAVisualPreviewProps {
  src: string;
  className?: string;
}

const DEFAULT_PLAYBACK_RATE = 0.4;

export const DefaultCTAVisualPreview: FC<DefaultCTAVisualPreviewProps> = ({
  src,
  className,
}) => (
  <video
    ref={(el) => {
      if (el) {
        el.playbackRate = DEFAULT_PLAYBACK_RATE;
      }
    }}
    autoPlay
    loop
    muted
    playsInline
    preload="auto"
    src={src}
    className={className ?? "h-full w-full object-contain"}
  />
);
